import {
  DeleteTripDocumentResponse,
  AttachDocumentResponse,
  DetachDocumentResponse,
  GetTripDocumentURLResponse,
  GetTripDocumentsResponse,
  UploadTripDocumentResponse,
} from './types'
import { baseUri, getOptions } from '../utils'

import request from 'api/requestUtils'

export type GetTripDocumentsParams = {
  tripId: string
}

export type GetTripDocumentURLParams = {
  documentKey: string
}

export async function getTripDocuments(
  { tripId }: GetTripDocumentsParams,
  accessToken?: string,
): Promise<GetTripDocumentsResponse['result']> {
  const uri = `${baseUri}/${tripId}/documents`
  return request
    .get<GetTripDocumentsResponse>(uri, getOptions(accessToken))
    .then((response) => response.result)
}

export async function getTripDocumentURL(
  { documentKey }: GetTripDocumentURLParams,
  accessToken?: string,
): Promise<GetTripDocumentURLResponse['result']> {
  const uri = `${baseUri}/${documentKey}`
  return request
    .get<GetTripDocumentURLResponse>(uri, getOptions(accessToken))
    .then((response) => response.result)
}

export type UploadTripDocumentParams = {
  tripId: string
  tripItemId?: string
  file: File
  onProgress?: (percentage: number) => void
}

export async function uploadTripDocument({
  tripId,
  tripItemId,
  file,
  onProgress,
}: UploadTripDocumentParams): Promise<UploadTripDocumentResponse['result']> {
  const uri = tripItemId ?
    `${baseUri}/${tripId}/documents/${tripItemId}/${file.name}` :
    `${baseUri}/${tripId}/documents/${file.name}`

  const formData = new FormData()
  formData.append('file', file)

  return request
    .upload<UploadTripDocumentResponse>(
      {
        path: uri,
        data: formData,
        options: { method: 'PUT', credentials: 'include' },
      },
      onProgress,
    )
    .then((response) => response.result)
}

export type DeleteTripDocumentParams = {
  documentKey: string
}

export async function deleteTripDocument({
  documentKey,
}: DeleteTripDocumentParams): Promise<DeleteTripDocumentResponse['result']> {
  const uri = `${baseUri}/${documentKey}`
  return request
    .delete<DeleteTripDocumentResponse>(uri, getOptions())
    .then((response) => response.result)
}

export type AttachDocumentToTripItemParams = {
  tripId: string
  tripItemId: string
  filename: string
}

export async function attachTripDocumentToTripItem({
  tripId,
  tripItemId,
  filename,
}: AttachDocumentToTripItemParams): Promise<AttachDocumentResponse['result']> {
  const uri = `${baseUri}/${tripId}/documents/${filename}`

  return request.patch(uri, { tripItemId }, getOptions())
}

export async function detachTripDocumentToTripItem({
  tripId,
  tripItemId,
  filename,
}: AttachDocumentToTripItemParams): Promise<DetachDocumentResponse['result']> {
  const uri = `${baseUri}/${tripId}/documents/${tripItemId}/${filename}`

  return request.patch(uri, { detach: true }, getOptions())
}
